import React, { useRef } from "react";
import Header from "./Header";
import Footer from "./Footer";
import { useState, useEffect } from "react";
import { Helmet } from "react-helmet";


<Helmet>
  <title>Reviews & Testimonials| Trusted Insurance Provider | Kora Insurance</title>
  <meta name="description" content="Read real customer testimonials about their experience with YourBrand’s insurance platform." />
  <meta name="keywords" content="Insurance Ghana, Family Insurance, Affordable Cover, Kora Insurance" />
  <meta name="robots" content="index, follow" />
  <link rel="canonical" href="https://korame.com.gh"/>
  {/* Open Graph tags */}
  <meta property="og:title" content="Best Online Insurance Platform" />
  <meta property="og:description" content="Compare and buy insurance plans with ease." />
  <meta property="og:url" content="https://korame.com.gh/" />
  <meta property="og:type" content="website" />
</Helmet>



const Testimonials = () => {
  const scrollContainerRef = useRef(null);

  const testimonials = [
    {
      company: "Atibie Nursing & Midwifery College",
      testimony: "\"Best decision was choosing Kora for our family's insurance needs. Their policies are competitively priced and their advisors take time to understand your specific situation. Five stars for reliability and service.\"",
      author: "Miss Pappoe",
      title: "Kaneshie, Accra",
      image: "/assets/Testimony 1.jpg"
    },


    {
      company: "Agnes Ofori Comm. Hospital",
      testimony: "\"Running a medical practice, I see insurance claims daily. Kora system is exemplary - clean interface, rapid processing, clear communication. They've modernized insurance.",
      author: "George Kwame Egeh",
      title: "Administrator",
      image: "/assets/Testimony 2.jpg"


    },
    {
      company: "Hubtel Limited",
      testimony: "\"Worth every penny. Signed up online in minutes, great rates, and when I needed them, they delivered. Claim processed in 36 hours, no paperwork chase.\"",
      author: "Henry",
      title: "Dispatch rider",
      image: "/assets/Testimony 3.jpg"
    },
  ];

  const videoTestimonials = [
    {
      id: 1,
      videoUrl: "https://player.vimeo.com/video/1056774835",
      title: "Customer Video 1"
    },
    {
      id: 2,
      videoUrl: "https://player.vimeo.com/video/1054345583",
      title: "Customer Video 2"
    },
    {
      id: 3,
      videoUrl: "https://player.vimeo.com/video/1054345629",
      title: "Customer Video 3"
    }
  ];

  const scrollLeft = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({ left: -300, behavior: 'smooth' });
    }
  };

  const scrollRight = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({ left: 300, behavior: 'smooth' });
    }
  };

  const [currentIndex, setCurrentIndex] = useState(0);
  // const totalTestimonials = testimonials.length;

  const handleScroll = () => {
    if (scrollContainerRef.current) {
      const { scrollLeft, clientWidth } = scrollContainerRef.current;
      const newIndex = Math.round(scrollLeft / clientWidth);
      setCurrentIndex(newIndex);
    }
  };

  // Attach scroll listener
  useEffect(() => {
    const container = scrollContainerRef.current;
    if (container) {
      container.addEventListener("scroll", handleScroll);
      return () => container.removeEventListener("scroll", handleScroll);
    }
  }, []);


  return (
    <div className="testimonials-page">
      <style>
        {`
          .testimonials-page footer {
            background-color: #fff !important;
            color: #0000 !important;
          }
          .testimonials-page footer .footer-section h3 {
            color: #ffff !important;
          }
          .testimonials-page footer .footer-section a,
          .testimonials-page footer .footer-section p {
            color: #ffff !important;
          }
          .testimonials-page footer .footer-bottom {
            border-top: 1px solid #ccc !important; 
          }
          
          @media (max-width: 768px) {
            .testimonials-page {
              overflow-x: hidden;
            }
          }
        `}
      </style>

      <Header />
      <div style={{
        backgroundColor: '#fff',
        minHeight: '100vh',
        paddingTop: '6rem',
        paddingBottom: '3rem',
        width: '100%',
        overflowX: 'hidden'
      }}>
        <div style={{
          width: '90%',
          maxWidth: '1200px',
          margin: '0 auto',
          padding: '0 1rem',
          textAlign: 'center'
        }}>
          <h1 style={{
            fontSize: 'clamp(1.5rem, 5vw, 2.5rem)',
            fontWeight: '600',
            color: '#000',
            marginBottom: '1rem'
          }}>
            Hear From Those Who Chose Us
          </h1>
          <p style={{
            fontSize: 'clamp(0.9rem, 3vw, 1.1rem)',
            color: '#666',
            marginBottom: '2rem'
          }}>
            Stories of transformation and success from the people who trusted our journey.
          </p>
        </div>

        <div style={{
          width: '90%',
          maxWidth: '1200px',
          margin: '0 auto',
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
          gap: '1.5rem',
          marginTop: '2rem',
          padding: '0 1rem'
        }}>
          {videoTestimonials.map((video) => (
            <div key={video.id} style={{
              background: '#fff',
              border: '1px solid #e5e7eb',
              borderRadius: '0.75rem',
              overflow: 'hidden',
              position: 'relative',
              width: '100%',
              aspectRatio: '16/9',
              // paddingBottom: '56.25%',
            }}>
              <iframe
                src={video.videoUrl}
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                  border: 'none'
                }}
                allow="autoplay; fullscreen; picture-in-picture"
                allowFullScreen
                title={video.title}
              />
            </div>
          ))}
        </div>


        <div style={{
          marginTop: '4rem',
          position: 'relative',
          background: '#fff',
          padding: '2rem 0',
          width: '100%'
        }}>
          {/* Horizontal Divider */}
          <div style={{
            width: '100%',
            height: '1px',
            background: 'linear-gradient(to right, transparent,rgb(219, 220, 223), transparent)', // Gradient divider
            margin: '2rem 0'
          }} />

          <div style={{
            width: '90%',
            maxWidth: '1200px',
            margin: '0 auto',
            position: 'relative',
            padding: '0 1rem'
          }}>
            <h2 style={{
              color: '#111',
              fontSize: 'clamp(1.2rem, 4vw, 1.5rem)',
              fontWeight: '600',
              marginBottom: '1rem',
              textAlign: 'center'
            }}>
              More Stories from Our Customers
            </h2>

            {/* Navigation buttons - hidden on mobile */}
            <button
              onClick={scrollLeft}
              style={{
                position: 'absolute',
                top: '50%',
                left: '0',
                transform: 'translateY(-50%)',
                background: 'rgba(255,255,255,0.1)',
                border: 'none',
                cursor: 'pointer',
                color: '#fff',
                padding: '0.5rem 1rem',
                fontSize: '1.5rem',
                borderRadius: '0 0.5rem 0.5rem 0',
                display: window.innerWidth <= 768 ? 'none' : 'block',
                zIndex: 1
              }}
              aria-label="Scroll left"
            >‹</button>
            <button
              onClick={scrollRight}
              style={{
                position: 'absolute',
                top: '50%',
                right: '0',
                transform: 'translateY(-50%)',
                background: 'rgba(255,255,255,0.1)',
                border: 'none',
                cursor: 'pointer',
                color: '#fff',
                padding: '0.5rem 1rem',
                fontSize: '1.5rem',
                borderRadius: '0.5rem 0 0 0.5rem',
                display: window.innerWidth <= 768 ? 'none' : 'block',
                zIndex: 1
              }}
              aria-label="Scroll right"
            >›</button>

            <div
              ref={scrollContainerRef}
              style={{
                display: 'flex',
                justifyContent: 'center',
                gap: '1.5rem',
                overflowX: 'auto',
                scrollBehavior: 'smooth',
                padding: '1rem',
                scrollSnapType: 'x mandatory',
                WebkitOverflowScrolling: 'touch',
                msOverflowStyle: 'none',
                scrollbarWidth: 'none'
              }}
            >
              {testimonials.map((item, index) => (
                <div key={index} style={{
                  background: '#fff',
                  borderRadius: '0.5rem',
                  flex: '0 0 calc(100% - 2rem)',
                  maxWidth: window.innerWidth <= 768 ? '100%' : '300px',
                  padding: '2rem',
                  color: '#111',
                  minHeight: '250px',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-between',
                  boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                  scrollSnapAlign: 'start'
                }}>
                  {/* 🔹 User Image - Circular Mask */}
                  <div style={{
                    width: "60px",
                    height: "60px",
                    borderRadius: "50%", // Circular shape
                    overflow: "hidden",
                    marginBottom: "1rem"
                  }}>
                    <img
                      src={item.image}
                      alt={item.author}
                      style={{ width: "100%", height: "100%", objectFit: "cover" }}
                    />
                  </div>
                  <div>
                    <h3 style={{
                      fontSize: 'clamp(0.9rem, 2.5vw, 1rem)',
                      fontWeight: '600',
                      marginBottom: '0.5rem'
                    }}>
                      {item.company}
                    </h3>
                    <p style={{
                      fontSize: 'clamp(0.8rem, 2vw, 0.9rem)',
                      fontStyle: 'italic',
                      marginBottom: '1rem'
                    }}>
                      {item.testimony}
                    </p>
                  </div>
                  <div>
                    <p style={{
                      margin: 0,
                      fontSize: 'clamp(0.75rem, 2vw, 0.85rem)',
                      fontWeight: '600'
                    }}>{item.author}</p>
                    <p style={{
                      margin: 0,
                      fontSize: 'clamp(0.7rem, 1.8vw, 0.8rem)',
                      color: '#999'
                    }}>{item.title}</p>
                  </div>
                </div>
              ))}
            </div>
            {/* 🔹 Scroll Indicator Dots */}
            <div style={{ textAlign: "center", marginTop: "1rem" }}>
              {testimonials.map((_, index) => (
                <span
                  key={index}
                  style={{
                    display: "inline-block",
                    width: "10px",
                    height: "10px",
                    margin: "0 5px",
                    backgroundColor: index === currentIndex ? "#fff" : "#666",
                    borderRadius: "50%",
                    transition: "background-color 0.3s ease"
                  }}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Testimonials;
